import {Typography} from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {styled} from "@mui/material/styles";
import {StrapiImageAsset} from "@/components/StrapiImageAsset";
import {grey} from "@mui/material/colors";

export const PartnerEntry = ({partner, ...props}) => {

    const PartnerEntryStyled = styled((props) => <Box {...props} />)(
        ({theme}) => ({
            "& a": {
                transition: "all .2s ease-in-out",
                color: theme.palette.secondary.main,
                textDecoration: "none",
                "&:visited": {
                    color: theme.palette.secondary.main,
                },
                "&:hover": {
                    color: theme.palette.secondary.main,
                    opacity: ".75",
                },
                "&:active": {
                    color: theme.palette.secondary.main,
                    opacity: "1",
                },
            },
            "& .container": {
                backgroundColor: grey[100],
                padding: "2rem",
            },
            "& .image--wrapper": {
                position: "relative",
                aspectRatio: "16 / 9",
                "& img": {
                    mixBlendMode: "multiply",
                },
            },
        })
    );

    return (
        <>
            <PartnerEntryStyled>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box className="container">
                            <Box className="image--wrapper">
                                <StrapiImageAsset
                                    strapiImageObject={partner.logo}
                                    layout="fill"
                                    objectFit="contain"
                                    width={500}
                                    height={500}
                                    fixedHeight={true}
                                />
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                        <Typography
                            variant="h4"
                            component="p"
                            color="common.black"
                            sx={{mb: 1}}
                        >
                            {partner.name}
                        </Typography>

                        <Typography variant="body1" sx={{mb: 2}}>
                            {partner.text}
                        </Typography>
                        {partner.link && (
                            <a href={partner.link}
                               target="_blank"
                               rel="noopener noreferrer"
                            >
                                {partner.link}
                            </a>
                        )}
                    </Grid>
                </Grid>
            </PartnerEntryStyled>
        </>
    );
};
